<script>
import _ from 'lodash';

export default {
    name: "BreadCrumbs",
    computed: {
        items() {
            if (!this.$store.getters.breadCrumbs) {
                return [];
            }
            return _(this.$route.matched)
                .filter(route => route.instances.default?.breadcrumb)
                .map(route => {
                    return Object.assign(
                        {
                            to: Object.assign(route.redirect || {name: route.name}, {params: this.$route.params}),
                            exact: true,
                        },
                        route.instances.default.breadcrumb
                    );
                })
                .value();
        }
    },
}
</script>

<template>
    <v-container v-if="items.length" fluid>
        <v-card>
            <v-breadcrumbs :items="items"></v-breadcrumbs>
        </v-card>
    </v-container>
</template>

<style scoped lang="scss">

</style>
